module.exports = __webpack_public_path__ + "static/media/Tollinton Market and Railway Building Labor Returns.c501e7b4.jpg";